import React from "react";
import { dataFormatters } from "../../../utils/dataFormatters";
import CertifyContainer from "./CertifyTest/CertifyContainer";
import moment from "moment";
import { tick_char } from "../../jobBriefing/JobBrieifingReport/special-char";
import "./BlueCard.css";
import { themeService } from "../../../theme/service/activeTheme.service";
import { formFeildStyle } from "../../../wigets/forms/style/formFields";
import { languageService } from "../../../Language/language.service";
import { blueCardMethods } from "./HelperMethods";

export const SelectField = (props) => {
  let selectedOption = "";
  if (props.options && props.options.length) {
    const match = props.options.find((item) => item.val === props.value);
    if (match) {
      selectedOption = match.text;
    }
  }

  return (
    <div
      style={{
        ...themeService(formFeildStyle.feildStyle),
        display: "inline-block",
        margin: "0",
        width: "90%",
      }}
    >
      <select
        title={selectedOption}
        style={{
          ...themeService(formFeildStyle.inputStyle),
          width: "100%",
          maxWidth: "100%",
          cursor: "pointer",
          fontSize: "18px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        onChange={(e) => props.changeHandler(e, false, "select")}
        onBlur={(e) => props.changeHandler(e, true, "select")}
        {...props.inputFieldProps}
        value={props.value}
      >
        {props.options &&
          props.options.map((item, index) => (
            <option key={index} value={item.val} title={item.text}>
              {languageService(item.text)}
            </option>
          ))}
      </select>
    </div>
  );
};

export function checkBoxComp(check) {
  return (
    <span
      className="bluecard-checkbox-size"
      style={{
        width: "30px",
        height: "30px",
        border: "2px solid black",
        textAlign: "center",
        marginInlineEnd: "5px",
        fontWeight: "700",
        fontSize: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {check ? tick_char : ""}
    </span>
  );
}

export function periodicFormatter(values, isDate) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [val1, val2] = values;
    result = val1 ? val1 : val2;
    if (result) {
      if (isDate) {
        result = dataFormatters.dateFormatter(result);
      }
    }
  }
  return (
    <span style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
      {result}
    </span>
  );
}

export function oouCertifyFormatter(values, period, assetId, handleCertifyClick) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [val1] = values;
    result = val1;
    let resultData = result[period + "Data"];
    let Cert = result[period + "Cert"];
    let pendingCertify = result[`${period}blueCardCertify`] && result[`${period}blueCardCertify`].pendingCertify;
    return (
      <div style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
        {!pendingCertify && (
          <CertifyContainer
            certifiedBy={Cert}
            oouPeriodDetails={resultData}
            assetId={assetId}
            handleCertifyClick={handleCertifyClick}
            type="oou"
          />
        )}
      </div>
    );
  }
  return result;
}

export function oouStartDateFormatter(values, period, assetId, handleCertifyClick, reportYear) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [val1] = values;
    result = val1;
    let resultData = result[period + "Data"];
    let Cert = result[period + "Cert"];
    let pendingCertify = result[`${period}blueCardCertify`] && result[`${period}blueCardCertify`].pendingCertify;
    let outOfUseDate = Cert
      ? getOutOfUseDateBasedOnYear(resultData && resultData.start, resultData && resultData.end, reportYear)
      : { start: resultData && resultData.start, end: resultData && resultData.end };
    return (
      <div style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
        {dataFormatters.dateFormatter(outOfUseDate && outOfUseDate.start)}
      </div>
    );
  }
  return result;
}

export function oouEndDateFormatter(values, period, assetId, handleCertifyClick, reportYear) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [val1] = values;
    result = val1;
    let resultData = result[period + "Data"];
    let Cert = result[period + "Cert"];
    let pendingCertify = result[`${period}blueCardCertify`] && result[`${period}blueCardCertify`].pendingCertify;
    let outOfUseDate = Cert
      ? getOutOfUseDateBasedOnYear(resultData && resultData.start, resultData && resultData.end, reportYear)
      : { start: resultData && resultData.start, end: resultData && resultData.end };
    return (
      <div style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
        {dataFormatters.dateFormatter(outOfUseDate && outOfUseDate.end)}
      </div>
    );
  }
  return result;
}

export function oouDateDifferenceCal(values, period, assetId, handleCertifyClick, reportYear) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [val1] = values;
    result = val1;
    let resultData = result[period + "Data"];
    let Cert = result[period + "Cert"];
    let pendingCertify = result[`${period}blueCardCertify`] && result[`${period}blueCardCertify`].pendingCertify;
    let outOfUseDate = Cert
      ? getOutOfUseDateBasedOnYear(resultData && resultData.start, resultData && resultData.end, reportYear)
      : { start: resultData && resultData.start, end: resultData && resultData.end };

    let diff = blueCardMethods.calculateOOUDays(resultData && resultData.start, resultData && resultData.end);

    return (
      <div style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
        {outOfUseDate && outOfUseDate.start && outOfUseDate.end ? diff : ""}
      </div>
    );
  }
  return result;
}

function getOutOfUseDateBasedOnYear(start, end, year) {
  let startDateToRet = start ? moment(new Date(start)) : null;
  let endDateToRet = end ? moment(new Date(end)) : null;
  const startOfYear = moment(new Date(year, 0, 1));
  const endOfYear = moment(new Date(year, 11, 31, 23, 59, 59, 999));

  startDateToRet = startDateToRet && startDateToRet.isBefore(startOfYear) ? startOfYear : startDateToRet;
  endDateToRet = endDateToRet && endDateToRet.isAfter(endOfYear) ? endOfYear : endDateToRet;

  return {
    start: startDateToRet,
    end: endDateToRet,
  };
}

export function checkBox(values, label) {
  let result = (
    <span style={{ display: "flex", alignItems: "center" }}>
      {checkBoxComp(false)}
      <span style={{ fontWeight: "bold" }}>{label}</span>
    </span>
  );
  if (values && Array.isArray(values)) {
    for (let val of values) {
      // result = <TickBox flag={val1} label={label} style={{ fontWeight: "bold" }} />;
      if (val && val.testConfigured) {
        result = (
          <span style={{ display: "flex", alignItems: "center" }}>
            {checkBoxComp(val && val.testConfigured)}
            <span style={{ fontWeight: "bold" }}>{label}</span>
          </span>
        );
      }

      return result;
    }
  }
  return result;
}

export function periodicItemFormatter(values, isAssisting) {
  let data = "";
  let result = "";
  if (values && Array.isArray(values)) {
    const [val1, val2] = values;
    data = val1 ? val1 : val2;

    if (data) {
      const items = [];
      for (let i = 1; i <= 7; i++) {
        let itemId = isAssisting ? `item${i}_assistingInspector` : `item${i}`;
        if (data[itemId]) {
          items.push(i);
        }
      }
      result = items.join(", ");
    }
  }
  return (
    <span style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
      {result}
    </span>
  );
}

export function periodicCertifyFormatter(values, period, handleCertifyClick, nextPeriod) {
  let result = "";
  let toReturn = null;
  if (values && Array.isArray(values)) {
    const [val1] = values;
    result = val1;
    if (result) {
      let Cert = result[period + "Cert"];
      let ids = result[`${period}blueCardCertify`] && result[`${period}blueCardCertify`].testSchedulesList;
      let userList = result[`${period}blueCardCertify`] && result[`${period}blueCardCertify`].userList;
      let pendingCertify = result[`${period}blueCardCertify`] && result[`${period}blueCardCertify`].pendingCertify;
      toReturn = (ids || Cert) && !pendingCertify && (
        <div>
          <CertifyContainer certifiedBy={Cert} testIds={ids} userList={userList} handleCertifyClick={handleCertifyClick} type="test" />
        </div>
      );
      if (!toReturn) {
        let Cert = result[nextPeriod + "Cert"];
        let ids = result[`${nextPeriod}blueCardCertify`] && result[`${nextPeriod}blueCardCertify`].testSchedulesList;
        let userList = result[`${nextPeriod}blueCardCertify`] && result[`${nextPeriod}blueCardCertify`].userList;
        let pendingCertify = result[`${nextPeriod}blueCardCertify`] && result[`${nextPeriod}blueCardCertify`].pendingCertify;
        toReturn = (ids || Cert) && !pendingCertify && (
          <div>
            <CertifyContainer certifiedBy={Cert} testIds={ids} userList={userList} handleCertifyClick={handleCertifyClick} type="test" />
          </div>
        );
      }
    }
  }
  return toReturn;
}

export function annualNoOfDaysFormatter(currentYearEntry, prevYearEntry) {
  if (currentYearEntry && currentYearEntry.noOfDays) {
    return currentYearEntry.noOfDays;
  } else if (prevYearEntry && prevYearEntry.noOfDays) {
    return prevYearEntry.noOfDays;
  }
  return null;
}

export function fragmentedFormatter(values, label) {
  let result = label;
  if (values && Array.isArray(values)) {
    for (let val of values) {
      if (val) {
        if (val.period1FormData && val.period1FormData.fragmented) {
          return (
            <span>
              <span style={{ marginLeft: "-10px", fontWeight: "bold" }}>{result}</span> (Fragmented)
            </span>
          );
        }
      }
    }
  }

  return <span style={{ marginLeft: "-10px", fontWeight: "bold" }}>{result}</span>;
}

export function testPressureFormatter(values) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [val1, val2] = values;

    if (val1) {
      result = val1;
    } else if (val2) {
      result = "Drilled";
    }
  }

  return result;
}

export function waverOtherFormatter(values) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [waiverTypeData] = values;
    if (waiverTypeData) {
      let latestPeriodArray = extractPeriods(waiverTypeData);
      let latestPeriod = latestPeriodArray.length > 0 ? latestPeriodArray[latestPeriodArray.length - 1] : null;
      result = waiverTypeData[`${latestPeriod}FormData`].waiverother;
      return result;
    }
  }

  return result;
}
export function waverTypeFormatter(values, type) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [waiverTypeData] = values;
    result = [];
    if (waiverTypeData) {
      let latestPeriodArray = extractPeriods(waiverTypeData);
      latestPeriodArray.forEach((period) => {
        if (waiverTypeData[`${period}FormData`].waiverType === type) {
          result.push(waiverTypeData[`${period}FormData`].waivernumber);
        }
      });
    }
  }

  return <div style={{ wordBreak: "break-word" }}>{result.join(", ")}</div>;
}

export function annualPrevTestFormatter(val) {
  if (val && val.prevDate) {
    let date = dataFormatters.dateFormatter(val.prevDate);
    let place = val.prevPlace;

    return (
      <div className="prevTestDateAndPlaceFormatterDiv">
        <p style={{ marginBottom: 0 }} className="prevTestDateAndPlaceFormatterP">
          {date}
        </p>
        <p style={{ marginBottom: 0 }} className="prevTestDateAndPlaceFormatterP">
          {place}
        </p>
      </div>
    );
  }

  return "";
}

export function afmPrevDateFormatter(val) {
  if (val && val.prevDate) {
    let date = dataFormatters.dateFormatter(val.prevDate);

    return date;
  }

  return "";
}

export function periodicPrevPlaceFormatter(val) {
  if (val && val.prevPlace) {
    return val.prevPlace;
  }
}

export function periodicPrevDateFormatter(val) {
  if (val && val.prevDate) {
    let date = dataFormatters.dateFormatter(val.prevDate);

    return date;
  }

  return "";
}

export function annualDateAndPlaceFormatter(val) {
  if (val && val.period1Date) {
    let date = dataFormatters.dateFormatter(val.period1Date);
    let place = val.period1blueCardCertify && val.period1blueCardCertify.certify ? "" : val.period1Place;

    return (
      <div className="prevTestDateAndPlaceFormatterDiv">
        <p style={{ marginBottom: 0 }} className="prevTestDateAndPlaceFormatterP">
          {date}
        </p>
        <p style={{ marginBottom: 0 }} className="prevTestDateAndPlaceFormatterP">
          {place}
        </p>
      </div>
    );
  }

  return "";
}

export function annualPersonConductingFormatter(val, selectedPerformedByUser, handlePerformedByUserChange) {
  if (val && val.period1blueCardCertify && val.period1blueCardCertify.userList && !val.period1blueCardCertify.pendingCertify) {
    const optionsList = [{ val: "", text: "Select" }, ...val.period1blueCardCertify.userList.map((u) => ({ val: u.id, text: u.name }))];

    return (
      <SelectField
        options={optionsList}
        changeHandler={handlePerformedByUserChange}
        value={selectedPerformedByUser ? selectedPerformedByUser : ""}
      />
    );
  }
  if (val && val.period1Name) {
    return val.period1Name;
  }

  return "";
}

export function annualCertifyFormatter(selectedEntry, selectedPerformedByUser, handleCertifyClick) {
  if (!selectedEntry) return;
  const selectedBlueCard = selectedEntry.period1blueCardCertify;

  if (selectedBlueCard && selectedBlueCard.pendingCertify) return;

  return (
    <div style={{ marginTop: "-30px" }}>
      <CertifyContainer
        certifiedBy={selectedEntry.period1Cert}
        testIds={selectedBlueCard ? selectedBlueCard.testSchedulesList : []}
        userList={selectedBlueCard ? selectedBlueCard.userList : []}
        selectedPerformedByUser={selectedPerformedByUser}
        handleCertifyClick={handleCertifyClick}
        allowDisable={true}
        type="test"
      />
    </div>
  );
}

export function afmCertifyFormatter(val, handleCertifyClick, period) {
  let result = "";

  const data = val;

  if (!data) return;

  let date = data[`${period}Date`];
  let cert = data[`${period}Cert`];
  let ids = data[`${period}blueCardCertify`] && data[`${period}blueCardCertify`].testSchedulesList;
  let userList = data[`${period}blueCardCertify`] && data[`${period}blueCardCertify`].userList;
  let pendingCertify = data[`${period}blueCardCertify`] && data[`${period}blueCardCertify`].pendingCertify;

  let formattedDate = dataFormatters.dateFormatter(date);

  result = (
    <div>
      <p>{formattedDate}</p>
      {(ids || cert) && !pendingCertify && (
        <CertifyContainer
          certifiedBy={cert}
          testIds={ids}
          userList={userList}
          handleCertifyClick={handleCertifyClick}
          type="test"
          hideCertifiedName={true}
        />
      )}
    </div>
  );

  return result;
}

export function dateAndCertFormatter(values, period, handleCertifyClick) {
  let result = "";
  if (values && Array.isArray(values)) {
    const [data] = values;

    if (!data) return;

    let date = data[`${period}Date`];
    let cert = data[`${period}Cert`];
    let ids = data[`${period}blueCardCertify`] && data[`${period}blueCardCertify`].testSchedulesList;
    let userList = data[`${period}blueCardCertify`] && data[`${period}blueCardCertify`].userList;

    let formattedDate = dataFormatters.dateFormatter(date);
    if (ids || cert) {
      result = (
        <div>
          <p>{formattedDate}</p>
          <CertifyContainer certifiedBy={cert} testIds={ids} userList={userList} handleCertifyClick={handleCertifyClick} type="test" />
        </div>
      );
    }
  }
  return result;
}
export function multiTestsSectionFormatter(
  values,
  selectedPerformedByUser,
  handlePerformedByUserChange,
  type,
  handleCertifyClick,
  period,
  showNAIfTestNotConfigured,
) {
  if (!Array.isArray(values)) return "";

  let latestValidBlueCardEntry = null;
  let latestPeriod1CertEntry = null;
  let latestPrevDateEntry = null;
  let isTestConfigured = false;

  for (const val of values) {
    if (val && val.testConfigured) {
      isTestConfigured = true;
    }
    if (val && val.period1Date) {
      const blueCard = val.period1blueCardCertify;
      const hasValidBlueCard = val.period1Id && blueCard && blueCard.testSchedulesList;
      const hasPeriod1Cert = val.period1Cert;

      const currentDate = new Date(val.period1Date);

      if (hasValidBlueCard) {
        if (!latestValidBlueCardEntry || new Date(latestValidBlueCardEntry.period1Date) < currentDate) {
          latestValidBlueCardEntry = val;
        }
      } else if (hasPeriod1Cert) {
        if (!latestPeriod1CertEntry || new Date(latestPeriod1CertEntry.period1Date) < currentDate) {
          latestPeriod1CertEntry = val;
        }
      }
    }

    if (val && val.prevDate) {
      const currentDate = new Date(val.prevDate);
      if (!latestPrevDateEntry || new Date(latestPrevDateEntry.prevDate) < currentDate) {
        latestPrevDateEntry = val;
      }
    }
  }

  const selectedEntry = latestValidBlueCardEntry || latestPeriod1CertEntry;
  const selectedPrevDateEntry = selectedEntry || latestPrevDateEntry;

  if (showNAIfTestNotConfigured) {
    if (!isTestConfigured)
      return (
        <p style={{ display: "flex", alignItems: "center", flexDirection: "vertical", marginBottom: 0 }} className="oouCertifyFormatter">
          N/A
        </p>
      );
  }

  const funcType = {
    annualPersonConducting: () => annualPersonConductingFormatter(selectedEntry, selectedPerformedByUser, handlePerformedByUserChange),
    annualDateAndPlace: () => annualDateAndPlaceFormatter(selectedEntry),
    annualCertify: () => annualCertifyFormatter(selectedEntry, selectedPerformedByUser, handleCertifyClick),
    annualNoOfDays: () => annualNoOfDaysFormatter(selectedEntry, selectedPrevDateEntry),
    annualPrevTest: () => annualPrevTestFormatter(selectedPrevDateEntry),
    afmPrevDate: () => afmPrevDateFormatter(selectedPrevDateEntry),
    afmCertify: () => afmCertifyFormatter(selectedEntry, handleCertifyClick, period),
    periodicPrevPlace: () => periodicPrevPlaceFormatter(selectedPrevDateEntry),
    periodicPrevDate: () => periodicPrevDateFormatter(selectedPrevDateEntry),
  };
  return funcType[type]() || "";
}

export const extractPeriods = (data) => {
  const regex = /period(\d+)/g;
  const json = JSON.stringify(data);
  return json ? [...new Set(json.match(regex))].sort() : [];
};
export const getBlueCardAccessor = (lookup, period, certify) => {
  let accessor =
    (lookup &&
      lookup.forms.reduce((result, formCode) => {
        result.push(formCode);
        certify && result.push(`${formCode}.${period}blueCardCertify`);
        return result;
      }, [])) ||
    [];

  return accessor;
};

export const generatePeriodicSchema = (data, blueCardSectionLookupsObj, handleCertifyClick) => {
  const schemaRows = [];
  let periodic92Forms = (blueCardSectionLookupsObj.periodic92 && blueCardSectionLookupsObj.periodic92.forms) || [];
  let periodic184Forms = (blueCardSectionLookupsObj.periodic184 && blueCardSectionLookupsObj.periodic184.forms) || [];
  [...periodic92Forms, ...periodic184Forms].forEach((formCode) => {
    const grouped = (data[formCode] || {}).grouped || [];
    for (let i = 0; i < grouped.length; i++) {
      let [period1, period2] = grouped[i];
      let section = generatePeriodicSection(formCode, period1.period, handleCertifyClick, period2 && period2.period);
      schemaRows.push({ section: section, date: data[formCode][`${period1.period}Date`] });
    }
  });

  const periodsOutOfUse = extractPeriods(data.OutOfUse);
  const assetId = data && data.assetId;
  periodsOutOfUse.forEach((period) => {
    let section = generateOOUSection("OutOfUse", period, handleCertifyClick, assetId, data.reportYear);
    schemaRows.push({ section: section, date: data.OutOfUse[`${period}StartDate`] });
  });
  const sortedSchemaRows = schemaRows.sort((a, b) => new Date(a.date) - new Date(b.date)).map((obj) => obj.section);

  while (sortedSchemaRows.length < 4) {
    let section = generatePeriodicSection();
    sortedSchemaRows.push(section);
  }
  return sortedSchemaRows;
};

const generatePeriodicSection = (type, period, handleCertifyClick, nextPeriod) => {
  return {
    heights: { header1: "50px" },
    classes: { header1: "avoid-break-inside-theSection" },
    inlineData: true,
    columns: [
      {
        title: "13. Date: Mo/Day/Yr1",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        // className: "tbl-text-normal",
        accessor: [`${type}.${period}Date`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => periodicFormatter(val, true),
      },
      {
        title: "14. Place1",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}.${period}Place`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => periodicFormatter(val),
      },
      {
        title: "15. Items*1",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}.${period}FormData`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => periodicItemFormatter(val, false),
      },
      {
        title: "16. Person Conducting1",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}.${period}Name`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => periodicFormatter(val),
      },
      ...(!nextPeriod && period
        ? [
            {
              title: "15. Items*2",
              colSpan: 3,
              rowSpan: 1,
              leftAlign: true,
              // topAlign: true,
              className: "tbl-text-normal",
              accessor: "",
              isValueOnly: true,
              dontJoinValues: true,
              formatter: (val) => {
                return (
                  <span style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
                    N/A
                  </span>
                );
              },
            },
            {
              title: "16. Person Conducting2",
              colSpan: 3,
              rowSpan: 1,
              leftAlign: true,
              // topAlign: true,
              className: "tbl-text-normal",
              accessor: "",
              isValueOnly: true,
              dontJoinValues: true,
              formatter: (val) => {
                return (
                  <span style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
                    N/A
                  </span>
                );
              },
            },
          ]
        : [
            {
              title: "15. Items*2",
              colSpan: 3,
              rowSpan: 1,
              leftAlign: true,
              // topAlign: true,
              className: "tbl-text-normal",
              accessor: [`${type}.${nextPeriod}FormData`],
              isValueOnly: true,
              dontJoinValues: true,
              formatter: (val) => periodicItemFormatter(val),
            },
            {
              title: "16. Person Conducting2",
              colSpan: 3,
              rowSpan: 1,
              leftAlign: true,
              // topAlign: true,
              className: "tbl-text-normal",
              accessor: [`${type}.${nextPeriod}Name`],
              isValueOnly: true,
              dontJoinValues: true,
              formatter: (val) => periodicFormatter(val),
            },
          ]),
      {
        title: "17. Certified by1",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        centerAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}`, `${type}.${period}blueCardCertify`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => periodicCertifyFormatter(val, `${period}`, handleCertifyClick, `${nextPeriod}`),
      },
    ],
  };
};
const generateOOUSection = (type, period, handleCertifyClick, assetId, reportYear) => {
  return {
    heights: { header1: "50px" },
    classes: { header1: "avoid-break-inside-theSection" },
    inlineData: true,
    // columns: [
    //   {
    //     title: "OOU",
    //     colSpan: 20,
    //     rowSpan: 1,
    //     leftAlign: true,
    //     topAlign: true,
    //     className: "tbl-text-normal",
    //     accessor: [`${type}`, `${type}.${period}Data`, `${type}.${period}blueCardCertify`],
    //     isValueOnly: true,
    //     dontJoinValues: true,
    //     formatter: (val) => {
    //       return oouCertifyFormatter(val, `${period}`, assetId, handleCertifyClick, reportYear);
    //     },
    //   },
    // ],

    columns: [
      {
        title: "13. Date: Mo/Day/Yr1",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        dontJoinValues: true,
      },
      {
        title: "14. Place1",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => {
          return (
            <div style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
              OUT OF USE
            </div>
          );
        },
      },
      {
        title: "15. Items*1",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}`, `${type}.${period}Data`, `${type}.${period}blueCardCertify`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => {
          return oouStartDateFormatter(val, `${period}`, assetId, handleCertifyClick, reportYear);
        },
      },
      {
        title: "16. Person Conducting1",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}.${period}Name`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => {
          return (
            <div style={{ display: "flex", alignItems: "center", flexDirection: "vertical" }} className="oouCertifyFormatter">
              UNTIL
            </div>
          );
        },
      },
      {
        title: "15. Items*2",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}`, `${type}.${period}Data`, `${type}.${period}blueCardCertify`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => {
          return oouEndDateFormatter(val, `${period}`, assetId, handleCertifyClick, reportYear);
        },
      },
      {
        title: "16. Person Conducting2",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}`, `${type}.${period}Data`, `${type}.${period}blueCardCertify`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => {
          return oouDateDifferenceCal(val, `${period}`, assetId, handleCertifyClick, reportYear);
        },
      },
      {
        title: "17. Certified by1",
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: [`${type}`, `${type}.${period}Data`, `${type}.${period}blueCardCertify`],
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (val) => {
          return oouCertifyFormatter(val, `${period}`, assetId, handleCertifyClick, reportYear);
        },
      },
    ],
  };
};

export function generateYearlySection({
  blueCardSectionLookupsObj,
  selectedPerformedByUser,
  handlePerformedByUserChange,
  handleCertifyClick,
  sectionTitle,
  frequencyLabel,
  blueCardKey,
  showDaysColumn = false,
  fragmented = false,
  drilled = false,
  eventRecorderNa = false,
  showNAIfTestNotConfigured = false,
}) {
  const baseAccessor = getBlueCardAccessor(blueCardSectionLookupsObj[blueCardKey]);

  return {
    heights: { header1: "50px" },
    classes: { header1: "avoid-break-inside-theSection" },
    inlineData: true,
    columns: [
      {
        title: sectionTitle,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        ...(fragmented
          ? {
              formatter: (val) => fragmentedFormatter(val, <span style={{ fontWeight: "normal" }}>{sectionTitle}</span>),
              accessor: baseAccessor,
              isValueOnly: true,
              dontJoinValues: true,
              unBold: true,
            }
          : { isTitleOnly: true, unBold: true }),
      },

      ...(showDaysColumn
        ? [
            eventRecorderNa
              ? {
                  title: frequencyLabel,
                  formatter: (val) => {
                    return val ? "N/A" : "";
                  },
                  dontJoinValues: true,
                  colSpan: 3,
                  rowSpan: 1,
                  leftAlign: true,
                  topAlign: true,
                  unBold: true,
                  className: "tbl-text-normal",
                  accessor: "Event Recorder (N/A)",
                  valueOnNextLine: true,
                }
              : {
                  title: frequencyLabel,
                  formatter: (val) =>
                    multiTestsSectionFormatter(
                      val,
                      selectedPerformedByUser,
                      handlePerformedByUserChange,
                      "annualNoOfDays",
                      null,
                      null,
                      showNAIfTestNotConfigured,
                    ),
                  dontJoinValues: true,
                  colSpan: 3,
                  rowSpan: 1,
                  leftAlign: true,
                  topAlign: true,
                  className: "tbl-text-normal",
                  accessor: baseAccessor,
                  unBold: true,
                  valueOnNextLine: true,
                },
          ]
        : [
            {
              title: frequencyLabel,
              colSpan: 3,
              rowSpan: 1,
              leftAlign: true,
              topAlign: true,
              unBold: true,
              className: "tbl-text-normal",
              isTitleOnly: true,
            },
          ]),
      {
        title: "21. Person Conducting",
        dontJoinValues: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        className: "tbl-text-normal",
        ...(drilled
          ? {
              accessor: "Drilled",
              isValueOnly: true,
              formatter: (val) => {
                return val ? "Drilled" : "";
              },
            }
          : eventRecorderNa
            ? {
                accessor: "Event Recorder (N/A)",
                isValueOnly: true,
                formatter: (val) => {
                  return val ? "N/A" : "";
                },
              }
            : {
                formatter: (val) =>
                  multiTestsSectionFormatter(
                    val,
                    selectedPerformedByUser,
                    handlePerformedByUserChange,
                    "annualPersonConducting",
                    null,
                    null,
                    showNAIfTestNotConfigured,
                  ),
                accessor: baseAccessor,
                isValueOnly: true,
              }),
      },
      {
        title: "22. Test Date & Place",
        dontJoinValues: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        className: "tbl-text-normal",
        ...(drilled
          ? {
              accessor: "Drilled",
              isValueOnly: true,
              formatter: (val) => {
                return val ? "Drilled" : "";
              },
            }
          : eventRecorderNa
            ? {
                accessor: "Event Recorder (N/A)",
                isValueOnly: true,
                formatter: (val) => {
                  return val ? "N/A" : "";
                },
              }
            : {
                formatter: (val) =>
                  multiTestsSectionFormatter(
                    val,
                    selectedPerformedByUser,
                    handlePerformedByUserChange,
                    "annualDateAndPlace",
                    null,
                    null,
                    showNAIfTestNotConfigured,
                  ),
                accessor: baseAccessor,
                isValueOnly: true,
              }),
      },
      {
        title: "23. Certified by",

        dontJoinValues: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        ...(drilled
          ? {
              accessor: "Drilled",
              isValueOnly: true,
              formatter: (val) => {
                return val ? "Drilled" : "";
              },
            }
          : eventRecorderNa
            ? {
                accessor: "Event Recorder (N/A)",
                isValueOnly: true,
                formatter: (val) => {
                  return val ? "N/A" : "";
                },
              }
            : {
                className: "tbl-text-normal",
                formatter: (val) =>
                  multiTestsSectionFormatter(
                    val,
                    selectedPerformedByUser,
                    handlePerformedByUserChange,
                    "annualCertify",
                    handleCertifyClick,
                    null,
                    showNAIfTestNotConfigured,
                  ),
                accessor: getBlueCardAccessor(blueCardSectionLookupsObj[blueCardKey], "period1", true),
                isValueOnly: true,
              }),
      },
      {
        title: "24. Previous Test Date & Place",
        dontJoinValues: true,
        colSpan: 5,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        className: "tbl-text-normal",
        ...(drilled
          ? {
              accessor: "Drilled",
              isValueOnly: true,
              formatter: (val) => {
                return val ? "Drilled" : "";
              },
            }
          : eventRecorderNa
            ? {
                accessor: "Event Recorder (N/A)",
                isValueOnly: true,
                formatter: (val) => {
                  return val ? "N/A" : "";
                },
              }
            : {
                formatter: (val) =>
                  multiTestsSectionFormatter(
                    val,
                    selectedPerformedByUser,
                    handlePerformedByUserChange,
                    "annualPrevTest",
                    null,
                    null,
                    showNAIfTestNotConfigured,
                  ),
                accessor: baseAccessor,
                isValueOnly: true,
              }),
      },
    ],
  };
}



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/SchemaHelpers.jsx